module.exports = __webpack_public_path__ + "img/background-favourite.fef513d4.png";